"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardSectionType = exports.DashboardItemType = void 0;
var DashboardItemType;
(function (DashboardItemType) {
    DashboardItemType["Product"] = "product";
    DashboardItemType["Minibox"] = "minibox";
    DashboardItemType["Thumbnail"] = "thumbnail";
    DashboardItemType["Content"] = "content";
})(DashboardItemType || (exports.DashboardItemType = DashboardItemType = {}));
var DashboardSectionType;
(function (DashboardSectionType) {
    DashboardSectionType["Homepage"] = "homepage";
    DashboardSectionType["Mixed"] = "mixed";
})(DashboardSectionType || (exports.DashboardSectionType = DashboardSectionType = {}));
exports.default = { DashboardItemType: DashboardItemType, DashboardSectionType: DashboardSectionType };
//# sourceMappingURL=Dashboard.js.map